import { render } from "./WalletDeposit.vue?vue&type=template&id=c6a731da&scoped=true"
import script from "./WalletDeposit.vue?vue&type=script&lang=js"
export * from "./WalletDeposit.vue?vue&type=script&lang=js"

import "./WalletDeposit.vue?vue&type=style&index=0&id=c6a731da&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src338202144/src/web-app-vue-3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6a731da"]])

export default __exports__